import { Avatar } from '@wanjianshi/admin-ui';
import { useEffect, useState } from 'react';

interface UserAvatarProps {
  src?: string | null;
  alt?: string | null;
  size?: number;
}

export function UserAvatar({ src, alt, size = 32 }: UserAvatarProps) {
  const url = src?.trim() || undefined;
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [url]);

  const showImage = Boolean(url) && !failed;

  return (
    <Avatar
      size={size}
      src={showImage ? url : undefined}
      alt={alt || undefined}
      style={{
        background: '#24272c',
        color: '#fff',
        fontWeight: 600,
        fontSize: size <= 32 ? 14 : size * 0.4,
        ...(!showImage ? {
          border: 'none',
          boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.1)',
        } : {}),
      }}
      onError={() => {
        setFailed(true);
        return false;
      }}
    >
      W
    </Avatar>
  );
}
